import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React from 'react';
import { format, parseISO } from 'date-fns';
import { BusinessProviderPropType } from './types/business';
import { getBusinessSchemaType } from './utils/business';
import { Helmet } from '../../../modules/foundation/components/HelmetProvider';
var defaultProps = {
  authorName: '',
  description: ''
};
export default function PressArticleSchema(_ref) {
  var businessName = _ref.businessName,
    businessCategories = _ref.businessCategories,
    businessLogo = _ref.businessLogo,
    headline = _ref.headline,
    datePublished = _ref.datePublished,
    authorName = _ref.authorName,
    description = _ref.description;
  var data = {
    '@context': 'https://schema.org',
    '@type': 'NewsArticle',
    headline: headline,
    datePublished: format(parseISO(datePublished), 'yyyy-MM-dd'),
    description: description,
    publisher: {
      '@type': getBusinessSchemaType(businessCategories),
      name: businessName
    }
  };
  if (authorName) {
    data.author = {
      '@type': 'Person',
      name: authorName
    };
  }
  if (businessLogo) {
    data.publisher.logo = {
      '@type': 'ImageObject',
      url: businessLogo
    };
  }
  return /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json"
  }, JSON.stringify(data)));
}
PressArticleSchema.defaultProps = defaultProps;